module.exports = __webpack_public_path__ + "img/stage-5.2812ff3f.png";